{
  "exitAppPromptTitle": "Quitter le portail Analytics ?",
  "exitAppPromptMessage": "Vous êtes sur le point de quitter FarmHQ et d'ouvrir le portail FarmHQ Analytics dans un navigateur Web externe."
}
